import axios from 'axios';
import { datajs, disableElements, enableElements } from '../shared/utils';

export default class FormBlockForm {
	static init() {
		const formBlockForm = document.getElementById('form-block-form');

		if (!formBlockForm) {
			return;
		}

		formBlockForm.addEventListener('submit', (e) => {
			e.preventDefault();

			const submitBtn = datajs('form-block-submit-btn');
			const stateIndicator = datajs('btn-state-indicator', submitBtn);
			const validationMessage = datajs('form-block-validation-message');
			const validationMessageContent = datajs('form-block-validation-message-content');

			const formData = new FormData(formBlockForm);
			const formInputs = formBlockForm.querySelectorAll('input, textarea, button');
			const inEnglish = formData.get('in-english') === '1';

			const appGlobals = window.AppGlobals;
			const adminUrl = appGlobals.adminUrl;
			const title = inEnglish ? appGlobals.contactFormSuccessTitleEnglish : appGlobals.contactFormSuccessTitle || false;
			const message = inEnglish ? appGlobals.contactFormSuccessMessageEnglish : appGlobals.contactFormSuccessMessage || false;
			const errorMessage = inEnglish ? appGlobals.contactFormErrorMessageEnglish : appGlobals.contactFormErrorMessage || false;

			validationMessage.classList.add('d-none');

			const disableForm = () => {
				disableElements(formInputs);
				stateIndicator?.classList.remove('d-none');
			};

			const enableForm = () => {
				enableElements(formInputs);
				stateIndicator?.classList.add('d-none');
			};

			const onSuccess = () => {
				formBlockForm.classList.add('d-none');
				if (message) {
					validationMessageContent.innerHTML += `<p>${title} ${message}</p>`;
				}
				validationMessage.classList.add('success');
				validationMessage.classList.remove('d-none');
			};

			const onError = () => {
				formBlockForm.classList.add('d-none');
				validationMessageContent.innerHTML = `<p>${errorMessage}</p>`;
				validationMessage.classList.add('error', 'mt-2');
				validationMessage.classList.remove('d-none');

				setTimeout(resetForm, 10000);
			};

			const resetForm = () => {
				formBlockForm.reset();
				formBlockForm.classList.remove('d-none');
				validationMessage.classList.add('d-none');
				enableForm();
			};

			const sendToDynamics = typeof window?.MsCrmMkt?.MsCrmFormLoader?.sendFormCaptureToCrm === 'function';

			disableForm();

			if (sendToDynamics) {
				window.MsCrmMkt.MsCrmFormLoader.sendFormCaptureToCrm(formBlockForm)
					.then((response) => {
						const { SubmissionStatus } = JSON.parse(response);

						if (SubmissionStatus === 'Success') {
							onSuccess();
						} else {
							onError();
						}
					})
					.catch((error) => {
						console.error(error);
						onError();
					});
			} else {
				// Prepare form data
				formData.append('action', 'send_form_block_form');

				// Post form
				axios
					.post(`${adminUrl}admin-ajax.php`, formData)
					.then((response) => {
						const success = response?.data?.success || false;

						if (success) {
							onSuccess();
						} else {
							onError();
						}
					})
					.catch((error) => {
						console.error(error);
						onError();
					});
			}
		});
	}
}
